import React, { createContext, useRef, useState, useEffect } from "react";
import useOfflineClass from "@hooks/useOfflineClass";

const defaultState = {};

const AppContext = createContext(defaultState);

const AppProvider = ({ children }) => {

  const isOffline = useOfflineClass();

  const [offline, setOffline] = useState(false);
  const [uuid, setUuid] = useState(null);
  const headerRef = useRef(null);
  const stickyIsiRef = useRef(null);
  const isiRef = useRef(null);
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [showExitModal, setShowExitModal] = useState(false);
  const [showBookmarkModal, setShowBookmarkModal] = useState(false);
  const [exitUrl, setExitUrl] = useState("");
  const [showHcpModal, setShowHcpModal] = useState(false);
  const [hcpModalUrl, setHcpModalUrl] = useState("");
  const [theme, setTheme] = useState(null);

  useEffect(() => {
    setOffline(isOffline);
  }, [isOffline]);

  const openExitModal = (url) => {
    setExitUrl(url);
    setShowExitModal(true);
  };

  const closeExitModal = () => {
    setShowExitModal(false);

    // bug fix: prevent the modal from closing before the exit URL is opened
    // without this, the exit url clears too fast, and the browser opens a tab with the same url instead of the exit one
    setTimeout(() => {
      setExitUrl("");
    }, 100);
  };

  const openHcpModal = (url) => {
    setHcpModalUrl(url);
    setShowHcpModal(true);
  };

  const closeHcpModal = () => {
    setShowHcpModal(false);
  };

  const openBookmarkModal = (url) => {
    setShowBookmarkModal(true);
  };

  const closeBookmarkModal = () => {
    setShowBookmarkModal(false);
  };

  const changeThemeToBlack = () => {
    setTheme("black");
  };

  const resetTheme = () => {
    setTheme(null);
  };

  const store = {
    uuid,
    setUuid,
    headerRef,
    stickyIsiRef,
    isiRef,
    isHeaderVisible,
    setIsHeaderVisible,
    showExitModal,
    exitUrl,
    openExitModal,
    closeExitModal,
    showHcpModal,
    hcpModalUrl,
    openHcpModal,
    closeHcpModal,
    showBookmarkModal,
    openBookmarkModal,
    closeBookmarkModal,
    offline,
    theme,
    changeThemeToBlack,
    resetTheme,
  };

  return <AppContext.Provider value={store}>{children}</AppContext.Provider>;
};

export default AppContext;

export { AppProvider };
